<template>
	<div>
		<!-- 顶部 -->
		<div class="header-body">
			<Button type="primary" @click="add">添加</Button>
			<Form :label-width="80" inline>
				<FormItem label="景点名称" class="search-item">
					<Input @keydown.enter.native.prevent="getList(1)" v-model="search.name" placeholder="请输入景点名称" style="width: 200px;"></Input>
				</FormItem>
				<FormItem label="所属地">
					<Select v-model="search.province" style="width:150px">
				        <Option v-for="(item,index) in cityData" :value="item" :key="index">{{ item }}</Option>
				    </Select>
				</FormItem>
				<Button type="info" @click="getList(1)">搜索</Button>
				<Button type="default" @click="clearSearch" icon="md-refresh"></Button>
			</Form>
		</div>
		<Divider />
		<!-- table -->
		<Table :columns="columns" :data="data" border></Table>
		<!-- 分页 -->
		<div class="page-body">
			<Page :total="total" :current='page' @on-change="changePage" show-elevator show-total/>
		</div>
		
		<!-- 新增 -->
		<Modal v-model="addShow" :title="addTitle" width="1300" :mask-closable="false">
			<Form ref="formData" :model="formData" :rules="ruleFormData" :label-width="80">
				<Row>
					<Col span="12">
						<FormItem label="名称" prop="name">
							<Input v-model="formData.name" placeholder="请输入景点名称" style="width: 500px;"></Input>
						</FormItem>
						<FormItem label="所属地" prop="province">
							<Select v-model="formData.province" style="width:300px">
						        <Option v-for="(item,index) in cityData" :value="item" :key="index">{{ item }}</Option>
						    </Select>
						</FormItem>
						<FormItem label="简述">
							<Input type="textarea" v-model="formData.desc" placeholder="请输入地址" style="width: 500px;" :rows="4"/>
						</FormItem>
						<FormItem label="AI简介">
							<Input type="textarea" v-model="formData.ai_desc" placeholder="请输入简述" style="width: 500px;" :rows="18"/>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="图片">
							<Uploads v-if="addShow" :images="formData.img" :count="4" @send-img="getImg"></Uploads>
						</FormItem>
						<FormItem label="游玩攻略">
							<Input type="textarea" v-model="formData.gonglue" style="width: 500px;" :rows="25"/>
						</FormItem>
					</Col>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="default" @click="addShow = false;">取消</Button>
				<Button type="primary" @click="submit">提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import Uploads from '@/components/Uploads'
	import { getTravel, addTravel,getTravelDetail,editTravel,deleteTravel,changeTravelCustom } from '@/utils/wenxue.js'
	import constant from '@/constant/index';
	export default {
		name: 'Travel',
		components: {
			Uploads
		},
		data() {
			return {
				cityData:constant.city,
				search:{
					name:'',
					province:''
				},
				page:1,
				total:0,
				data: [],
				columns: [
					{
						title:'序号',
						width:80,
						align:'center',
						render:(h,param)=>{
							return h('span',{},param.index - 0 + 1)
						}
					},
					{
						title:'名称',
						width:200,
						align:'center',
						key:'name'
					},
					{
						title:'所属地',
						width:150,
						align:'center',
						key:'province'
					},
					{
						title:'简述',
						minWidth:300,
						align:'left',
						key:'desc'
					},
					{
						title: '推荐',
						width: 200,
						align: 'center',
						render:(h,param)=>{
							var _that = this;
							return h('i-switch',{
								props:{
									value:param.row.is_custom == 1 ? false : true,
									size:'large'
								},
								on:{
									'on-change':()=>{
										changeTravelCustom({id:param.row.id}).then((res)=>{
											_that.$Message.info('操作成功');
											//_that.getList(_that.page);
										})
									}
								}
							},[
								h('span',{slot:'open'},'是'),
								h('span',{slot:'close'},'否')
							])
						}
					},
					{
						title: '操作',
						minWidth: 150,
						align: 'center',
						render: (h, param) => {
							var _that = this;
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '6px'
									},
									on: {
										'click': function() {
											_that.formData.id = param.row.id;
											_that.getTravelDetail();
										}
									}
								}, '编辑'),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {

									},
									on: {
										'click': function() {
											_that.$Modal.confirm({
												title: '删除确认',
												content: '该操作不可逆，是否确认删除？',
												onOk: function() {
													deleteTravel({
														id: param.row.id
													}).then(res => {
														_that.$Message.info('操作成功');
														let index = null;
														_that.data.forEach((e, key) => {
															if(e.id == res) {
																index = key;
															}
														})

														if(index !== null) _that.data.splice(index, 1);
													})
												}
											})
										}
									}
								}, '删除')
							])
						}
					}
				],
				addShow: false,
				addTitle:'添加景点',
				formData: {
					id:0,
					name:'',
					province:'',
					img:[],
					ai_desc:'',
					gonglue:'',
					desc:''
				},
				ruleFormData:{
					name:[{
						required: true,
						message: '请输入景点名称',
						trigger: 'blur'
					}],
					province:[{
						required: true,
						message: '请选择所属地',
						trigger: 'change'
					}],
				}
			}
		},
		methods: {
			changePage(page){
				this.getList(page);
			},
			async getList(page) {
				this.page = page;
				const param = {
					page:page || 1,
					page_num:10,
					name:this.search.name,
					province:this.search.province
				};
				
				const data = await getTravel({form:param});

				this.data = data['data'];
				this.total = data['total'];
			},
			add() {
				this.addShow = true;
				this.addTitle = '添加景点';
				
				this.formData.id = 0;
				this.formData.name = '';
				this.formData.province = '山西';
				this.formData.img = [];
				this.formData.ai_desc = '';
				this.formData.gonglue = '';
				this.formData.desc = '';
			},
			getImg(img) {
				this.formData.img = img;
			},
			submit() {				
				var _that = this;
				this.$refs['formData'].validate((valid) => {
					if(valid) {
						const param = { ..._that.formData};
						
						if(param.id > 0) {
							editTravel({
								form: param
							}).then((res) => {
								_that.$Message.info('编辑成功');
								_that.addShow = false;
								_that.getList(_that.page);
							})
						} else {
							addTravel({
								form: param
							}).then((res) => {
								_that.$Message.info('添加成功');
								_that.addShow = false;
								_that.getList();
							})
						}
					}
				})
			},
			getTravelDetail(){
				getTravelDetail({id:this.formData.id || 0}).then((res)=>{
					this.addShow = true;
					this.addTitle = '编辑景点';
					this.formData = {...res};
				})
			},
			clearSearch(){
				this.search.name = '';
				this.search.province = '';
				
				this.getList();
			}
		},
		mounted() {
			this.getList();
		}
	}
</script>

<style scoped>
	.ivu-layout {
		height: 100vh !important;
	}
	
	.header-body {
		width: 100%;
		min-height: 36px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.ivu-divider-horizontal {
		margin: 12px !important;
	}
	.page-body{
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 12px;
	}
	.search-item{
		margin-bottom: 0px !important;
	}
</style>


// WEBPACK FOOTER //
// src/views/wenxue/Travel.vue